import * as selectors from './selectors'
import * as actions from './actions'

import slice from './reducer'
import saga from './saga'

const reducer = slice.reducer

export { selectors, actions, reducer, saga }
